export default __webpack_public_path__ + "static/media/Whatsapp.cace04e3.svg";